import axios from 'axios';
import {Loading} from 'element-ui';

// axios.defaults.headers["token"] = sessionStorage.getItem('token') ? sessionStorage.getItem('token') : ''; /* 让ajax携带cookie */

export default {
  allsearchUrl: 'https://allsearch.yuntsg.com',
  publicUrl:'https://lib.shgh.cn',
  zhytsgUrl:'https://zhytsg.yuntsg.com',
  userUrl:'https://user.tsgyun.com',
  fulltextUrl:'https://fulltext.yuntsg.com',//全文请求
  meshUrl:'https://mesh.yuntsg.com',//mesh
  ipJudge:-1,
  loginFlag:false,//登录标识
  companyIp:'',//单位ip
  request,
  formatTime,
  getUserInfo,
  // commonUserInfo:{},
  showLoading, hideLoading,
  data() {
    return {
      loading,
    }
  }
}

function request(method, url, params, form, showError, code,asyncFlag) {
  // console.log(params,'------params')
  var contetType = '', dataGet, dataPost;
  // showError 是否展示错误信息 不传默认为展示
  if (showError || showError == undefined) {
    showError = true
  } else {
    showError = false
  }
  if(asyncFlag||asyncFlag == undefined){
    asyncFlag = true
  }else{
    asyncFlag=false;
  }
  //返回值是否有code 不穿默认有
  if (code || code == undefined) {
    code = true
  } else {
    code = false
  }
  if (!form) {
    contetType = 'application/json'
  } else {
    contetType = 'application/x-www-form-urlencoded'
  }
  // if (method == 'get') {
  //   dataGet = params
  // } else {
  //   dataPost = params
  // }
  return new Promise((resolve, reject) => {
    axios({
      headers: {
        'Content-Type': contetType,
        // 'token':sessionStorage.getItem('token') ? sessionStorage.getItem('token') : '' /* 让ajax携带cookie */
      },
      method: method,
      async:asyncFlag,
      url: url,
      data: params, //get 请求直接在请求url 后面拼接参数
      withCredentials: true,
    }).then((res) => {
      // console.log(res, '---res')
      if(code){
        resolve(res.data)
      }else{
        resolve(res)
      }
      /* if(res.data.code==0){
         resolve(res.data.data)
       } else{
         this.hideLoading();
         if (showError){
           // that.$message({
           //     message: res.data.message,
           //     type: 'warning'
           // });
           console.log('错误信息')
         }
       }*/
    }).catch((res) => {
      this.hideLoading();
      if (showError) {
        // that.$message({
        //     message: res.data.message,
        //     type: 'warning'
        // });
        // console.log(res, '请求错误信息')

        // Message.error(res.data.message);
      }
    })
  })
}

// 展示loading
function showLoading() {
  let that= this;
  that.loading = Loading.service({
    lock: true,
    text: '加载中...',
    spinner: 'el-icon-loading',
    background: 'rgba(0, 0, 0, 0.7)'
  });
}

//隐藏loading
function hideLoading() {
  this.loading.close();
}

// 时间戳转换
function formatTime (timestamp,type) {
  // 计算年月日时分的函数
  var date = new Date(timestamp)
  var Y = date.getFullYear()
  var M = (date.getMonth() + 1)
  var D = date.getDate()
  var h = date.getHours() + ':'
  var m = date.getMinutes() + ':'
  var s = date.getSeconds()

  let time ='';
  if(type==0){//年月日
    time = Y+ '-' + M + '-' + D+ ' ';
  }else if(type==1){
    // 年
    time = Y;
  }else if(type==2){
    //月 日
    time= M +'/'+ D
  }
  return time
  // return Y + M + D + h + m + s
}

function getUserInfo(){
  let url= this.publicUrl+'/user/user';
    return new Promise((resolve, reject) => {
      request('post', url, '', true,true,true,false).then((res) => {
        let userInfo = res.data;
        if(userInfo){
          sessionStorage.setItem('userInfo', JSON.stringify(userInfo));
          this.loginFlag= true;
          console.log('true----已登录');
        }else{
          sessionStorage.setItem('userInfo', '');
          this.loginFlag= false;
          console.log('false---未登录');
        }
        resolve(userInfo)
      })
    });


}


// WEBPACK FOOTER //
// ./src/assets/common/utils.js